

























































































































































































































import Registration, { EmptyRegistration } from '@/models/registration';
import {
  ValidationObserver, ValidationProvider, configure, extend, setInteractionMode,
} from 'vee-validate';
import {
  // eslint-disable-next-line camelcase
  alpha_spaces, confirmed, email, min, regex, required,
} from 'vee-validate/dist/rules';
import Component from 'vue-class-component';
import RegistrationModule from '@/store/modules/registration.module';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import { mask } from 'vue-the-mask';

setInteractionMode('eager');

configure({
  classes: {
    invalid: 'is-invalid',
  },
});

extend('email', email);

extend('confirmed', confirmed);

extend('required', {
  ...required,
  message: 'This field is required',
});

extend('regex', regex);

extend('pw_min', {
  ...min,
  message: 'Should be aleast 8 characters long',
});

extend('one_number', {
  message: 'Should have atleast one number',
  validate: (value) => value.match(/[0-9]/g) !== null,
});

extend('one_letter', {
  message: 'Should have atleast one letter',
  validate: (value) => value.match(/[a-zA-Z]/g) !== null,
});

extend('alpha_spaces', alpha_spaces);

@Component({
  components: { ValidationObserver, ValidationProvider },
  directives: { mask },
})
export default class AccountCreateView extends Vue {
  registrationModule = getModule(RegistrationModule, this.$store);
  registration = EmptyRegistration;
  confirmPassword = '';

  mounted() {
    this.registration = { ...this.registrationModule.registration };
  }

  nextStep() {
    this.registrationModule.setRegistration(
      new Registration({ ...this.registration }),
    );
    this.$router.push('/confirm-account-details');
  }
}
